export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ14.504fe588.mp3";